// src/utils/imagenReintento.js
//
// Una imagen que no carga NO siempre está vencida.
// Caso real (28/10/2026, Producción → Pedidos Personalizados): fotos de pedidos del día anterior salían "Vencida" y
// recién aparecieron después de recargar la pantalla unas 6 veces. Las fotos existían (123 de 123, y el servidor las
// entregó bien en 738 de 738 intentos) y Firebase no tuvo fallas ese día: la falla fue momentánea, de la conexión de
// esa computadora, y la pantalla la daba por "vencida" al primer error y no volvía a intentar.
//
// Por eso, antes de dar una imagen por perdida:
//   1. se reintenta sola 2 veces (a los 1.5 s y a los 4 s). Cada intento lleva un parámetro extra en la dirección
//      (`_reintento=N`) para que el navegador no reuse el intento fallido; el almacenamiento lo ignora (probado);
//   2. si sigue sin cargar, se le pregunta al almacenamiento si el archivo existe, sin bajarlo (HEAD): 403/404/410 =
//      se borró de verdad ("vencida"); cualquier otra respuesta, o ninguna, = "no cargó" y se ofrece reintentar.
//      El bucket del ERP deja hacer esta consulta desde el ERP (CORS: GET y HEAD); otro sitio que no la deje cae en
//      "no cargó", nunca en "vencida" sin saberlo.
// Lo usan <ImagenEvidencia> (global) y el visor de la personalización en «Ver», con el hook useReintentoImagenes.

export const ESPERAS_REINTENTO_MS = [1500, 4000];

// La dirección para el intento N (0 = la original, sin tocar)
export function urlConReintento(url, intento) {
  if (!intento || typeof url !== 'string' || !/^https?:\/\//i.test(url)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}_reintento=${intento}`;
}

// 'vencida' si el archivo ya no existe; 'fallo' si existe o no se pudo saber
export async function comprobarImagen(url) {
  if (typeof url !== 'string' || !/^https?:\/\//i.test(url)) return 'vencida';
  try {
    const resp = await fetch(url, { method: 'HEAD', cache: 'no-store' });
    return (resp.status === 403 || resp.status === 404 || resp.status === 410) ? 'vencida' : 'fallo';
  } catch (e) {
    return 'fallo';
  }
}
